import React from 'react';
import { Dropdown, Image } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import { image } from "../../../../assets";
import { ENV } from '../../../../utils';
import { Menu } from 'lucide-react';  // Import Menu icon
import "./Logout.css";

export function Logout({ toggleSidebar, sidebarOpen }) {  // Accept props
    const { logout, user: { avatar } } = useAuth();
    const navigate = useNavigate();
    const onLogout = () => {
        logout();
        navigate("/");
    };

    const onPerfil = () => {
        navigate("/admin/perfil");
    };

    // Define los elementos del menú desplegable
    const menuItems = [
        { key: 'profile', text: 'Mi Perfil', icon: 'user', onClick: onPerfil },
        { key: 'logout', text: 'Cerrar Sesión', icon: 'sign-out', onClick: onLogout },
    ];

    const profileIconStyle = {
        fontSize: '20px',
        alignItems: 'center',
    };

    const imagenUrl = avatar ? `${ENV.USUSARIOS}/${avatar}` : image.noAvatar;

    return (
        <div className="header-container">
            <button
                className="sidebar-toggle-btn"
                onClick={toggleSidebar}
                aria-label="Toggle sidebar menu"
            >
                <Menu size={24} />
            </button>

            <div className="logout-container">
                <Dropdown
                    icon={null}
                    trigger={(
                        <div>
                            <div>
                                <Image avatar src={imagenUrl} style={profileIconStyle} />
                            </div>
                        </div>
                    )}
                    pointing='top right'
                    options={menuItems}
                />
            </div>
        </div>
    );
}